import FigmaDashboardIcon from './FigmaDashboardIcon';

interface Properties {
  width?: number;
  height?: number;
}

const DashboardIcon = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDashboardIcon width={width} height={height} color='#121826' />;
};

export default DashboardIcon;
